import { posts } from '@/mocks/campusData';
import { catOf } from './common';

const stats = [
  { num: '1,200+', label: '累计复盘事件' },
  { num: '380+', label: '辟谣求真条目' },
  { num: '24', label: '今日上新瓜' },
  { num: '98%', label: '完结率不烂尾' },
];

export default function Hero() {
  const feature = posts.find((p) => p.feature) ?? posts[0];
  const cat = catOf(feature.categoryKey);

  return (
    <section id="top" className="mx-auto max-w-6xl px-4 md:px-6">
      {/* 头条区域：不对称头版 */}
      <div className="grid grid-cols-1 items-center gap-8 py-10 md:grid-cols-12 md:py-14">
        <div className="md:col-span-6">
          <div className="flex flex-wrap items-center gap-2 text-xs font-medium text-stone-500">
            <span className="inline-flex items-center gap-1 rounded-full bg-red-600 px-2.5 py-1 text-white">
              <i className="ri-fire-fill text-[12px]" /> 今日头版
            </span>
            <span>2026-09-09 · 周三</span>
            <span className="hidden items-center gap-1 sm:inline-flex">
              <i className="ri-radio-2-line text-red-500" /> 校园吃瓜实时追踪中
            </span>
          </div>

          <h1 className="mt-5 font-editorial text-3xl font-black leading-tight text-stone-900 md:text-[44px] md:leading-[1.15]">
            反转不只在一瞬间，
            <br />
            吃瓜要吃全套真相。
          </h1>
          <p className="mt-5 max-w-xl text-sm leading-relaxed text-stone-600 md:text-base">
            从最初的爆料，到发酵中的变体，再到辟谣、反转与最终复盘——我们专注把校园里每一桩热议事件的来龙去脉完整拼齐，
            <strong className="font-semibold text-stone-900">不追一半、不烂尾</strong>，理性求证，看反转打脸也守住底线。
          </p>

          <div className="mt-6 flex flex-wrap gap-3">
            <a
              href="#feed"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-red-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-red-700"
            >
              <i className="ri-arrow-right-up-line text-base" /> 立即开吃最新瓜
            </a>
            <a
              href="#timeline"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-stone-300 bg-white px-5 py-2.5 text-sm font-semibold text-stone-800 transition hover:border-red-300 hover:text-red-700"
            >
              <i className="ri-loop-left-line text-base text-amber-500" /> 查看反转现场
            </a>
          </div>

          <div className="mt-9 grid grid-cols-2 gap-x-6 gap-y-5 border-t border-dashed border-stone-300 pt-6 sm:grid-cols-4">
            {stats.map((s) => (
              <div key={s.label}>
                <div className="font-editorial text-2xl font-black text-red-600">{s.num}</div>
                <div className="mt-1 text-xs text-stone-500">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="md:col-span-6">
          <a href="#feed" className="group relative block overflow-hidden rounded-xl" aria-label={feature.title}>
            <img
              src={feature.img}
              alt="奖学金内定名单反转事件：公示名单与评审记录还原真相的编辑部配图"
              title="奖学金名单反转 辟谣 真相复盘"
              className="aspect-[4/3] w-full rounded-xl object-cover object-top transition duration-500 group-hover:scale-[1.03]"
            />
            <div className="pointer-events-none absolute inset-0 rounded-xl bg-gradient-to-t from-stone-900/70 via-stone-900/10 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-5">
              <div className="mb-2 flex items-center gap-2">
                <Badge catKey={feature.categoryKey} />
                <span className="rounded-full bg-black/30 px-2 py-0.5 text-[11px] font-medium text-white backdrop-blur">
                  <i className="ri-flashlight-fill mr-0.5 text-amber-300" />
                  热度 {feature.heat}
                </span>
              </div>
              <h3 className="font-editorial text-lg font-bold leading-snug text-white">{feature.title}</h3>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}

function Badge({ catKey }: { catKey: string }) {
  const c = catOf(catKey);
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold text-white ${catKey === 'fanzhuan' ? 'bg-red-500' : catKey === 'piyao' ? 'bg-teal-600' : 'bg-amber-500'}`}>
      <i className={`${c.icon} text-[11px]`} />
      {c.name}
    </span>
  );
}